// src/DeviceActions.js
import React from "react";
import "./DeviceActions.css";

const DeviceActions = ({
  isCollapsed,
  onToggleCollapse,
  onExecuteAction,
  loadingAction,
  dragHandleProps,
  onDownloadSettings,
  onUpdateFirmware,
  isDownloadingSettings,
}) => {
  return (
    <div className="device-actions-container">
      <h2 onClick={onToggleCollapse} {...dragHandleProps}>
        Device Actions
        <span className="collapse-icon">{isCollapsed ? "▼" : "▲"}</span>
      </h2>
      {!isCollapsed && (
        <div className="actions-buttons">
          <button
            className={`action-button ${
              loadingAction === "TOGGLE" ? "working" : ""
            }`}
            onClick={() => onExecuteAction("TOGGLE")}
            disabled={!!loadingAction}
          >
            {loadingAction === "TOGGLE" ? "Working..." : "Toggle Lock State"}
          </button>
          <button
            className={`action-button ${
              loadingAction === "PASS_THRU" ? "working" : ""
            }`}
            onClick={() => onExecuteAction("PASS_THRU")}
            disabled={!!loadingAction}
          >
            {loadingAction === "PASS_THRU"
              ? "Working..."
              : "Momentary Unlock Access"}
          </button>
          <button
            className={`action-button ${
              loadingAction === "FREEZE" ? "working" : ""
            }`}
            onClick={() => onExecuteAction("FREEZE")}
            disabled={!!loadingAction}
          >
            {loadingAction === "FREEZE"
              ? "Working..."
              : "Freeze/Unfreeze Lock State"}
          </button>
          <button
            className={`action-button ${
              loadingAction === "NORMAL" ? "working" : ""
            }`}
            onClick={() => onExecuteAction("NORMAL")}
            disabled={!!loadingAction}
          >
            {loadingAction === "NORMAL"
              ? "Working..."
              : "Set Normal Lock State"}
          </button>
          <button
            className={`action-button firmware-button ${
              loadingAction === "FIRMWARE_UPDATE" ? "working" : ""
            }`}
            onClick={onUpdateFirmware}
            disabled={!!loadingAction || isDownloadingSettings}
            title="Update device to latest firmware version (password protected)"
          >
            {loadingAction === "FIRMWARE_UPDATE"
              ? "Working..."
              : "Update Firmware"}
          </button>
          <button
            className={`action-button settings-button ${
              isDownloadingSettings ? "working" : ""
            }`}
            onClick={onDownloadSettings}
            disabled={!!loadingAction || isDownloadingSettings}
            title="Download complete device settings (password protected)"
          >
            {isDownloadingSettings
              ? "Generating..."
              : "Download Complete Device Settings"}
          </button>
        </div>
      )}
    </div>
  );
};

export default DeviceActions;
